<div class="component-wrapper">
    <form class="form" (ngSubmit)=sendResetMail() [formGroup]="requestPasswordResetForm">
        <div class="email">
            <kendo-formfield>
                <kendo-label class="form-label" [for]="benutzername" translate>auth.email</kendo-label>
                <kendo-textbox #benutzername [placeholder]="'auth.email' | translate" formControlName="email"
                    showSuccessIcon="initial" showErrorIcon="initial"></kendo-textbox>
                <kendo-formerror *ngFor="let errorMessage of benutzernameErrorMessages">{{errorMessage}}</kendo-formerror>
            </kendo-formfield>
        </div>
        <div class="links">
            <label>
                <span id="pre-register">{{'pre-register.alreadyRegistered' | translate}}</span>
                <a class="login-link" [routerLink]="['/authentication/login']" translate>auth.login</a>
            </label>
            <a *ngIf="!isRegistrationDisabled" class="registration-link" routerLink="/authentication/preregister"
                routerLinkActive="active">
                <span translate>auth.register</span>
            </a>
        </div>

        <captcha-component formControlName="captchaChallengeResponse"></captcha-component>

        <div class="submit-wrapper">
            <button kendoButton class="reset" type="submit" [disabled]="requestPasswordResetForm.invalid || isLoading"
                [innerHTML]="'auth.reset_password' |translate"></button>
        </div>
    </form>
</div>